import { message } from 'antd';
import * as ApikoApi from '../../api/apiko-api';
import {
  fetchUsersSuccess,
  fetchUsersRequest,
  fetchUsersFailure,
  deleteUser,
  restoreUser,
  changeUserRole,
} from '../actions/users';

/**
 * fetchUsers :: () -> Func -> Promise Error _
 */
export const fetchUsers = () => dispatch =>
  Promise.resolve(dispatch(fetchUsersRequest()))
    .then(() => ApikoApi.fetchUsers())
    .then(result => dispatch(fetchUsersSuccess(result)))
    .catch(() => dispatch(fetchUsersFailure()));

/**
 * handleUserDelete :: ID -> Func -> Promise Error _
 */
export const handleUserDelete = _id => dispatch =>
  ApikoApi.deleteUserById(_id)
    .then(user => dispatch(deleteUser(user)))
    .then(() => message.success('User successfully removed'))
    .catch(err => message.error(err.response.data.error.message));

/**
 * handleChangeUserRole :: (String, Object) -> Func -> Promise Error _
 */
export const handleChangeUserRole = (_id, data) => dispatch =>
  ApikoApi.changeUserRole(_id, data)
    .then(user => dispatch(changeUserRole(user)))
    .then(() => message.success('User role successfully changed'))
    .catch(err => message.error(err.response.data.error.message));

/**
 * handleUserRestore :: String -> Func -> Promise Error _
 */
export const handleUserRestore = _id => dispatch =>
  ApikoApi.restoreUser(_id)
    .then(user => dispatch(restoreUser(user)))
    .then(() => message.success('Invitation successfully sent to user via email'))
    .catch(err => message.error(err.response.data.error.message));



// WEBPACK FOOTER //
// ./src/redux/thunk/users.js